<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <!-- Title page -->
            <h1 class="page__title">{{ $t(titlePage) }}</h1>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid>
                <CRow>
                    <CCol sm="12">
                        <CCard>
                            <CCardBody>
                                <CTabs variant="tabs" :active-tab="0">
                                    <!-- General -->
                                    <CTab :title="$t('general')">
                                        <CCard bodyWrapper>
                                            <h6>
                                                {{
                                                    $t(
                                                        "Create a group of shipping campaigns. With which you can make shipments to several clients with different balancing logics."
                                                    )
                                                }}
                                            </h6>
                                            <br />
                                            <CInput
                                                :isValid="
                                                    checkIfFormValid({
                                                        formName: 'group',
                                                        fieldName: 'name',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.group.name.$model
                                                "
                                                :label="$t('name')"
                                                :placeholder="
                                                    $t('Enter the name')
                                                "
                                                :invalidFeedback="
                                                    $t('Name is required')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />

                                            <SelectAsync
                                                :isValid="
                                                    checkIfFormValid({
                                                        formName: 'group',
                                                        fieldName:
                                                            'shipment_balancing_type',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.group
                                                        .shipment_balancing_type
                                                        .$model
                                                "
                                                :label="$t('type')"
                                                :placeholder="
                                                    $t('Select an option')
                                                "
                                                :invalidFeedback="
                                                    $t('Type is requiered')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                                optionsValue="id"
                                                optionsLabel="name"
                                                endpoint="/shipment.balancing.api/types"
                                            />

                                            <div class="form-group form-row">
                                                <label
                                                    class="col-form-label col-sm-2 col-form-label-sm"
                                                    >{{
                                                        $t(
                                                            "Return priority response"
                                                        )
                                                    }}</label
                                                >
                                                <div class="col-sm-10">
                                                    <CSwitch
                                                        :checked.sync="
                                                            $v.forms.group
                                                                .return_priority_response
                                                                .$model
                                                        "
                                                        color="primary"
                                                        name="action"
                                                        shape="pill"
                                                        variant="3d"
                                                        size="sm"
                                                    />
                                                </div>
                                            </div>
                                            <div class="form-group form-row">
                                                <label
                                                    class="col-form-label col-sm-2 col-form-label-sm"
                                                    >{{ $t("Active") }}</label
                                                >
                                                <div class="col-sm-10">
                                                    <CSwitch
                                                        :checked.sync="
                                                            $v.forms.group
                                                                .active.$model
                                                        "
                                                        color="primary"
                                                        name="action"
                                                        shape="pill"
                                                        variant="3d"
                                                        size="sm"
                                                    />
                                                </div>
                                            </div>
                                            <CInput
                                                :value.sync="
                                                    $v.forms.group
                                                        .capping_count_ok.$model
                                                "
                                                type="number"
                                                :placeholder="
                                                    $t(
                                                        'Enter a maximum oks limit'
                                                    )
                                                "
                                                :label="$t('Capping count ok')"
                                                :invalidFeedback="
                                                    $t('Limit is invalid')
                                                "
                                                class="mb-0"
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                        </CCard>
                                    </CTab>

                                    <!-- Customers tabs -->
                                    <CTab :title="$t('members')">
                                        <CCard>
                                            <CCardBody>
                                                <CustomTable
                                                    :items="
                                                        tables.members.items
                                                    "
                                                    :fields="
                                                        traslateLabels(
                                                            tables.members
                                                                .fields
                                                        )
                                                    "
                                                    :resizable="false"
                                                >
                                                    <template #id="{ index }">
                                                        {{ index + 1 }}
                                                    </template>
                                                    <template
                                                        #client_id="{ index }"
                                                    >
                                                        <SelectAsync
                                                            :placeholder="
                                                                $t(
                                                                    'Select an option'
                                                                )
                                                            "
                                                            :isValid="
                                                                checkIfFormTableFieldValid(
                                                                    {
                                                                        tableName:
                                                                            'members',
                                                                        index,
                                                                        fieldName:
                                                                            'client_id',
                                                                    }
                                                                )
                                                            "
                                                            :invalidFeedback="
                                                                $t(
                                                                    'provider_is_required'
                                                                )
                                                            "
                                                            :optionsValue="'id'"
                                                            :optionsLabel="'name'"
                                                            size="sm"
                                                            endpoint="campaigns.api"
                                                            :value.sync="
                                                                $v.tables[
                                                                    'members'
                                                                ].items.$each[
                                                                    index
                                                                ].client_id
                                                                    .$model
                                                            "
                                                        />
                                                    </template>
                                                    <template
                                                        #priority="{ index }"
                                                    >
                                                        <CInput
                                                            :value.sync="
                                                                tables.members
                                                                    .items[
                                                                    index
                                                                ].priority
                                                            "
                                                            type="number"
                                                            :placeholder="
                                                                $t(
                                                                    'Enter a priority from 0 - 10'
                                                                )
                                                            "
                                                            :invalidFeedback="
                                                                $t(
                                                                    'Priority is invalid'
                                                                )
                                                            "
                                                            class="mb-0"
                                                            size="sm"
                                                        />
                                                    </template>
                                                    <template
                                                        #percentage="{ index }"
                                                    >
                                                        <CInput
                                                            :value.sync="
                                                                tables.members
                                                                    .items[
                                                                    index
                                                                ].percentage
                                                            "
                                                            type="number"
                                                            :placeholder="
                                                                $t(
                                                                    'Enter a percentage'
                                                                )
                                                            "
                                                            :invalidFeedback="
                                                                $t(
                                                                    'Percentage is invalid'
                                                                )
                                                            "
                                                            class="mb-0"
                                                            size="sm"
                                                        />
                                                    </template>
                                                    <template
                                                        #is_priority="{ index }"
                                                    >
                                                        <div
                                                            class="d-flex justify-content-center align-items-center"
                                                        >
                                                            <CInputCheckbox
                                                                name="is_priority"
                                                                :checked.sync="
                                                                    tables
                                                                        .members
                                                                        .items[
                                                                        index
                                                                    ]
                                                                        .is_priority
                                                                "
                                                                @update:checked="
                                                                    checkIsPriority(
                                                                        index
                                                                    )
                                                                "
                                                            />
                                                        </div>
                                                    </template>
                                                    <template
                                                        #options="{ index }"
                                                    >
                                                        <div
                                                            class="table-options"
                                                        >
                                                            <ButtonTrash
                                                                @click="
                                                                    deleteItemToTable(
                                                                        'members',
                                                                        index
                                                                    )
                                                                "
                                                            />
                                                        </div>
                                                    </template>
                                                    <template #no-items-view>
                                                        <div
                                                            class="block-no-items section"
                                                        >
                                                            <h2
                                                                class="section__title text-no-items"
                                                            >
                                                                {{
                                                                    $t(
                                                                        "Add member"
                                                                    )
                                                                }}
                                                            </h2>
                                                            <ButtonAdd
                                                                @click="
                                                                    addItemToTable(
                                                                        'members'
                                                                    )
                                                                "
                                                            />
                                                        </div>
                                                    </template>
                                                </CustomTable>
                                            </CCardBody>

                                            <CCardFooter
                                                v-if="
                                                    tables['members'].items
                                                        .length > 0
                                                "
                                            >
                                                <ButtonAdd
                                                    @click="
                                                        addItemToTable(
                                                            'members'
                                                        )
                                                    "
                                                />
                                            </CCardFooter>
                                        </CCard>
                                    </CTab>
                                </CTabs>
                            </CCardBody>
                            <CCardFooter class="d-flex">
                                <ButtonSave
                                    @click="submitForm($event, 'group')"
                                    :disabled="forms.group._loading"
                                />
                                <ButtonBack class="mr-3" />
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/** Components */
import SelectCountry from "£lement/SelectCountry";
import SelectAsync from "£lement/SelectAsync";
import LInputRadioGroup from "~/components/LInputRadioGroup";
import Calendar from "v-calendar/lib/components/calendar.umd";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import ButtonBack from "£lement/ButtonBack";
import ButtonSave from "~/components/ButtonSave.vue";
import FormSectionDescription from "~/components/FormSectionDescription.vue";
import FormSection from "~/components/FormSection.vue";
import CustomTable from "~/components/CustomTable";
import ButtonAdd from "~/components/ButtonAdd.vue";
import ButtonTrash from "~/components/ButtonTrash.vue";
/** Mixins */
import pageMixin from "~/mixins/page.js";
import formMixin from "~/mixins/form.js";
import tableMixin from "~/mixins/table.js";
import { validationMixin } from "vuelidate";

/** Others */
import { required } from "vuelidate/lib/validators";
import {
    cilSave,
    cilArrowThickFromRight,
    cilPlus,
    cilTrash,
    cilSettings,
} from "@coreui/icons";
import weekDaysOptions from "./config/options/week_days.js";
import IntervalsOptions from "./config/options/intervals.js";
import DeliveryCampaignGroupMembersTableConfig from "./config/tables/DeliveryCampaignGroupMembers.js";
import constants from "~/assets/constants.json";
export default {
    name: "DeliveryCampaignGroupsUpdatePage",
    middleware: ["auth", "page"],
    mixins: [validationMixin, pageMixin, formMixin, tableMixin],
    components: {
        SelectCountry,
        SelectAsync,
        Calendar,
        DatePicker,
        LInputRadioGroup,
        ButtonBack,
        ButtonSave,
        FormSectionDescription,
        FormSection,
        CustomTable,
        ButtonAdd,
        ButtonTrash,
    },
    icons: {
        cilSave,
        cilArrowThickFromRight,
        cilSettings,
        cilPlus,
        cilTrash,
    },
    options: {
        weekDays: weekDaysOptions,
        intervals: IntervalsOptions,
    },
    data() {
        return {
            forms: {
                group: {
                    name: null,
                    shipment_balancing_type: null,
                    return_priority_response: false,
                    members: [],
                    active: false,
                    capping_count_ok: null,
                    _loading: false,
                    _matchResponse: "_items",
                },
            },
            tables: {
                members: DeliveryCampaignGroupMembersTableConfig,
            },
        };
    },
    computed: {
        uuid: function () {
            return this.$route.params.uuid;
        },
    },
    watch: {
        "forms.group.members": {
            handler(oldValue, newValue) {
                this.tables.members.items = this.forms.group.members;
            },
            deep: true,
        },
        "forms.group.shipment_balancing_type": {
            handler(newValue, oldValue) {
                switch (newValue) {
                    case constants.SHIPMENT_BALANCING_TYPE_TO_ALL: // To all
                        this.tables.members.setFieldProperty("is_priority", "_active", true);
                        this.tables.members.setFieldProperty("priority", "_active", false);
                        this.tables.members.setFieldProperty("percentage", "_active", false);
                        break;
                    case constants.SHIPMENT_BALANCING_TYPE_BY_PRIORITY: // By priority
                        this.tables.members.setFieldProperty("is_priority", "_active", false);
                        this.tables.members.setFieldProperty("priority", "_active", true);
                        this.tables.members.setFieldProperty("percentage", "_active", false);
                        break;
                    case constants.SHIPMENT_BALANCING_TYPE_BY_PERCENTAGE: // By percentage
                        this.tables.members.setFieldProperty("is_priority", "_active", false);
                        this.tables.members.setFieldProperty("priority", "_active", false);
                        this.tables.members.setFieldProperty("percentage", "_active", true);
                        break;
                    default:
                        break;
                }
            },
            deep: true,
        },
    },
    validations: {
        forms: {
            group: {
                name: {
                    required,
                },
                shipment_balancing_type: {
                    required,
                },
                return_priority_response: {},
                active: {},
                capping_count_ok: {},
            },
        },
        tables: {
            members: {
                items: {
                    $each: {
                        client_id: {
                            required,
                        },
                        priority: {
                            required,
                        },
                        percentaje: {
                            required,
                        },
                    },
                },
            },
        },
    },
    methods: {
        async submitForm(e, formName) {
            if (e) e.preventDefault();
            await this.sendForm({
                formName,
                url: "/shipment.balancing.api/client-groups/" + this.uuid,
                method: "PUT",
                adapterData: (data) => {
                    return {
                        ...data,
                        members: this.tables.members.items,
                    };
                },
            });
            this.$router.go(-1);
        },

        checkIsPriority(indexItemSelected) {
            this.tables.members.items = this.tables.members.items.map(
                (item, index) => {
                    // Este paso es una redundancia pero funciona, no se por que pero si no los cambios del checkbox no se guardan
                    if (indexItemSelected == index) {
                        item.is_priority = item.is_priority;
                    } else {
                        item.is_priority = false;
                    }
                    return item;
                }
            );
        },

        async loadPageData() {
            await this.updateForm({
                formName: "group",
                url: `/shipment.balancing.api/client-groups/${this.uuid}`,
            });
        },
    },
    async mounted() {
        this.tables.members.items = [];
        await this.loadPageData();
        this.updatePageLoading(false);
    },
};
</script>

<style scoped lang="scss">
</style>
